import { useRoute } from "vue-router";
import { ref } from "vue";
import { apiFreeWeeklyList, apiRecipientGroupAll } from "@/request/api";

export default () => {
    const $route = useRoute();
    const makerId = $route.params.makerId; // 厂商id
    const weekList = ref([]); // 周报列表
    const groupDict = ref([]); // 收件人字典

    // 获取周报列表
    async function setWeekList() {
        const { data } = await apiFreeWeeklyList({ makerId });
        weekList.value = data || [];
        // weekList.value.unshift({ weeklyId: '', weeklyTitle: '全部' })
    }

    async function setGroupDict() {
        const { data } = await apiRecipientGroupAll();
        groupDict.value = data || [];
        groupDict.value = groupDict.value.map((first) => {
            first.id = first.groupId;
            first.name = first.groupName;
            if (first.recipientList?.length) {
                first.recipientList = first.recipientList.map((second) => {
                    second.id = second.id;
                    second.name = second.recipientName;
                    return second;
                });
            }
            return first;
        });
    }

    setGroupDict();

    return { weekList, groupDict };
};
